import { UseFormReturn } from 'react-hook-form';
import { coreDialogApi } from '@cp/entities/dialog';
import { MessageType } from '@common/model/dialog/message/messageType';
import { useCallback } from 'react';
import { useApiServerErrorHandler } from 'src/app/shared/hooks/useApiServerErrorHandler';
import { MemberUser } from '@youhelp-ru/core';
import { BotIdentificator } from '@common/model/bot';

const supportBot = MemberUser.bot(BotIdentificator.SupportBot);

/**
 * Отправляет сообщение клиенту в диалог Техподдержки
 */
export const useSendMessageToClient = () => {
  const [ensureDialog] = coreDialogApi.useCreateDialogMutation();
  const [sendMessage] = coreDialogApi.useSendMessageMutation();
  const handleApiServerError = useApiServerErrorHandler();

  return useCallback(
    async (
      { clientId, message, sendCopyBySms }: { clientId: number; message: string; sendCopyBySms?: boolean },
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      { form }: { form?: UseFormReturn<any> } = {},
    ) => {
      const dialogResponse = await ensureDialog({
        participant: MemberUser.client(clientId),
        as: supportBot,
      });

      if (dialogResponse.error) {
        handleApiServerError(dialogResponse.error, { form });
        return;
      }

      const response = await sendMessage({
        sendCopyBySms: sendCopyBySms ? 1 : undefined,
        dialogId: dialogResponse.data.id,
        payload: message,
        type: MessageType.Text,
        as: supportBot,
      });

      if ('error' in response && response.error) {
        handleApiServerError(response.error, { form });
        return;
      }
    },
    [ensureDialog, handleApiServerError, sendMessage],
  );
};
